import { CustomPageBlock } from 'src/types';
import css from './text-block.module.scss';
import Description from 'src/components/description-block/description';

export default function CustomPageTextBlock({ item }: Readonly<{ item: CustomPageBlock }>) {
  return (
    <div className={css.textBlock}>
      <div className={css.container}>
        <div className={css.textGroup}>
          <h1>{item.title}</h1>
          <Description className={css.description} description={item.description ?? ''} />
        </div>
      </div>
    </div>
  );
}
